"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'modal',
    props: {
        value: { type: Boolean }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const handleClose = () => {
            emit("input", false);
        };
        return { __sfc: true, props, emit, handleClose };
    }
});
